import { useParams } from 'react-router-dom';

export interface OnsiteCampaignUrlParams {
  siteId: string;
  campaignId: string;
}

export function useOnsiteCampaignUrlParams() {
  return useParams<OnsiteCampaignUrlParams>();
}
